export interface EntityNavItem {
  to: string;
  labelKey: string;
}

const entities: EntityNavItem[] = [
  {
    to: '/entity-management/case-types',
    labelKey: 'pages.entityManagement.items.caseTypes',
  },
  {
    to: '/entity-management/surgeons',
    labelKey: 'pages.entityManagement.items.surgeons',
  },
  {
    to: '/entity-management/tracked-asset-catalog',
    labelKey: 'pages.entityManagement.items.trackedAssetCatalog',
  },
  {
    to: '/entity-management/untracked-asset-catalog',
    labelKey: 'pages.entityManagement.items.untrackedAssetCatalog',
  },
  {
    to: '/entity-management/tracked-assets',
    labelKey: 'pages.entityManagement.items.trackedAssets',
  },
  {
    to: '/entity-management/preference-cards',
    labelKey: 'pages.entityManagement.items.preferenceCards',
  },
  {
    to: '/entity-management/count-sheets',
    labelKey: 'pages.entityManagement.items.countSheets',
  },
  {
    to: '/entity-management/location-types',
    labelKey: 'pages.entityManagement.items.locationTypes',
  },
  {
    to: '/entity-management/facilities',
    labelKey: 'pages.entityManagement.items.facilities',
  },
  {
    to: '/entity-management/locations',
    labelKey: 'pages.entityManagement.items.locations',
  },
];

// Named as a hook so it can access context/permissions in future without changing callers.
export function useEntityManagementViewModel():{entities: EntityNavItem[]} {
  return {
    entities,
  };
}
